import React from "react";
import { classNames } from "./utils";

interface AutoMessagesButtonProps {
  autoEnabled: boolean;
  onStopAuto: () => void;
  stopping: boolean;
}

export function AutoMessagesButton({
  autoEnabled,
  onStopAuto,
  stopping,
}: AutoMessagesButtonProps) {
  return (
    <div className="flex items-center justify-between border-b bg-gray-50 px-4 py-3 rounded-t-lg">
      <div className="flex items-center gap-2 text-sm">
        <span className="text-gray-700">
          {autoEnabled ? "Auto messages enabled" : "Auto messages disabled"}
        </span>
      </div>
      <button
        onClick={onStopAuto}
        disabled={stopping}
        className={classNames(
          "rounded-lg px-3 py-1.5 text-sm shadow-sm transition",
          stopping ? "bg-gray-200 text-gray-500" : 
          autoEnabled ? "bg-red-500 text-white hover:bg-red-600" : "bg-green-500 text-white hover:bg-green-600"
        )}
        aria-label={autoEnabled ? "Stop auto messages" : "Start auto messages"}
      >
        {stopping ? "Updating…" : autoEnabled ? "Stop auto" : "Start auto"}
      </button>
    </div>
  );
}

